import Vue from 'vue'
import VueRouter from 'vue-router'

// Routes
import dashboard from './routes/dashboard'
import pages from './routes/pages'
import uot from './routes/uot'
// import admin from './///routes/admin'

Vue.use(VueRouter)

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  scrollBehavior() {
    return { x: 0, y: 0 }
  },
  routes: [
    { path: '/', redirect: { name: 'auth' } },
    ...dashboard,
    ...pages,
    // ...admin,
    ...uot,
    {
      path: '*',
      redirect: 'error-404',
    },
  ],
})

// ? For splash screen
// Remove afterEach hook if you are not using splash screen
router.afterEach(() => {
  // Remove initial loading
  const appLoading = document.getElementById('loading-bg')
  if (appLoading) {
    appLoading.style.display = 'none'
  }
})

export default router
